const PATH = 'https://knp-ldkc-kpmr-serv.netlify.app/.netlify/functions';

module.exports = {
    PATH
};